import { render } from "./MovBanco.vue?vue&type=template&id=24840014&scoped=true"
import script from "./MovBanco.vue?vue&type=script&lang=js"
export * from "./MovBanco.vue?vue&type=script&lang=js"

import "./MovBanco.vue?vue&type=style&index=0&id=24840014&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24840014"]])

export default __exports__